import get from 'lodash/get';
import hostDefaultFields from 'store/Host/contextFields';

export const selectFields = (state) => {
  const fields = get(state, 'preferences.host_table', hostDefaultFields);
  const newFields = {};
  Object.keys(hostDefaultFields).forEach((key) => {
    const defaultField = hostDefaultFields[key];
    const field = get(fields, key, defaultField);
    newFields[key] = {
      ...defaultField,
      ...field
    };
  });
  return newFields;
};

export const selectHostList = (state) => get(state, 'host.hostList', []);
